export default function loadScript (src, done) {
  var js = document.createElement('script')
  js.src = src
  if (done) {
    js.onload = function () {
      done()
    }
    js.onerror = function () {
      done(new Error('Failed to load script ' + src));
    }
  }
  document.head.appendChild(js)
}



// WEBPACK FOOTER //
// ./inc/js/utils/load-script.js